export default __webpack_public_path__ + "static/media/help.c1640c5b.svg";